import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { useGeneral } from '../../../contexts';
import { HERO_IMAGES } from '../../../utils/constants';
import Button from '../../ui/Button/Button';
import styles from './HeroSection.module.css';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useGeneral();
  const { getTranslation } = language;
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % HERO_IMAGES.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev + 1) % HERO_IMAGES.length);
  };

  const handlePrev = () => {
    setCurrentImageIndex((prev) => (prev - 1 + HERO_IMAGES.length) % HERO_IMAGES.length);
  };

  const handleExplore = () => {
    navigate('/events');
  };

  const handleExploreCommunities = () => {
    navigate('/communities');
  };

  const isFirstSlide = currentImageIndex === 0;
  const isLastSlide = currentImageIndex === HERO_IMAGES.length - 1;

  // Determine content alignment class
  let contentAlignmentClass = '';
  if (isFirstSlide) {
    contentAlignmentClass = styles.contentLeft;
  } else if (isLastSlide) {
    contentAlignmentClass = styles.contentRight;
  } else {
    contentAlignmentClass = styles.contentCenter;
  }

  // Get slide-specific content
  const getSlideContent = () => {
    if (currentImageIndex === 0) {
      return {
        titleLines: [getTranslation('home.heroTitle1'), getTranslation('home.heroTitle2')],
        buttonText: getTranslation('home.heroButton1'),
        buttonAction: handleExplore
      };
    } else {
      return {
        titleLines: [getTranslation('home.heroTitle3'), getTranslation('home.heroTitle4')],
        buttonText: getTranslation('home.heroButton2'),
        buttonAction: handleExploreCommunities
      };
    }
  };

  const slideContent = getSlideContent();

  return (
    <section className={styles.hero}>
      <div 
        key={currentImageIndex}
        className={`${styles.heroVisual} ${styles.slideTransition} ${currentImageIndex === 0 ? styles.heroCenter : styles.heroTop}`}
        style={{ backgroundImage: `url(${HERO_IMAGES[currentImageIndex]})` }}
      >
        <div className={`${styles.content} ${contentAlignmentClass} ${styles.contentTransition}`}>
          <h1 className={styles.title}>
            <span className={styles.titleLine}>{slideContent.titleLines[0]}</span>
            <span className={styles.titleLine}>{slideContent.titleLines[1]}</span>
          </h1>
          <Button 
            variant="primary" 
            size="large"
            onClick={slideContent.buttonAction}
            className={styles.ctaButton}
          >
            {slideContent.buttonText}
          </Button>
        </div>
        
        {/* Previous button - show on middle and last slides */}
        {!isFirstSlide && (
          <div className={styles.controlsLeft}>
            <button className={styles.controlButton} onClick={handlePrev}>
              {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
              {/* @ts-ignore - react-icons compatibility with React 19 */}
              <HiChevronLeft size={20} />
            </button>
          </div>
        )}
        
        {/* Next button - show on first and middle slides */}
        {!isLastSlide && (
          <div className={styles.controlsRight}>
            <button className={styles.controlButton} onClick={handleNext}>
              {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
              {/* @ts-ignore - react-icons compatibility with React 19 */}
              <HiChevronRight size={20} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;

